import StudentSearch from './StudentSearch';

export default StudentSearch;
